import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { getSession } from "@sajilni/auth";

export const setupInterceptors = (axiosInstance: AxiosInstance): void => {
  // Request interceptor
  axiosInstance.interceptors.request.use(
    async (config) => {
      const session = await getSession();
      if (session) {
        config.headers["Authorization"] = `Bearer ${session.jwt}`;
      }
      console.log(config.headers);
      return config;
    },
    (error: any): Promise<any> => Promise.reject(error)
  );

  // Response interceptor
  axiosInstance.interceptors.response.use(
    (response: AxiosResponse): AxiosResponse => response,
    (error: any): Promise<any> => {
      if (error.response && error.response.status === 401) {
        // Redirect to a custom 401 page
        window.location.href = "/401";
      }
      return Promise.reject(error);
    }
  );
};
